import React from "react";
import ContactFeedback from "../components/ContactFeedback";

export default function ContactFeedbackPage() {
  return (
    <div style={{ padding: "40px" }}>
      <ContactFeedback />
    </div>
  );
}